import { Error, Loader, Accordions } from '../../../common'
import NonSecureMaterialsTestWindowPanel from './NonSecureMaterialsTestWindowPanel'
import {
  getOrdersNonSecureAncillaryMaterialsData,
  getOrdersNonSecureAncillaryMaterialsProps,
} from '../../../../selectors/order'
import {
  fetchCoordNonSecureAncillaryMaterials,
  setupNonSecureAncillaryMaterialsFormData,
  clearNonSecureAncillaryMaterialsFormData,
} from '../../../../actions/orders'
import { addFetchAction, removeFetchAction } from '../../../../actions/app'
import { OTHER_MATERIALS_FORM_NAME, PANEL_ORDER } from '../../../../constants/OrderConstants'

const mapStateToProps = state => {
  // TBD: Is it okay non-secure materials uses course exam windows?
  const { fetching, fetched, error } = getOrdersNonSecureAncillaryMaterialsProps(state)
  const allTestingMaterials = getOrdersNonSecureAncillaryMaterialsData(state)
  return {
    fetching,
    fetched,
    error,
    allTestingMaterials,
  }
}

const NonSecureMaterialsOrderForm = ({
  fetching,
  fetched,
  error,
  allTestingMaterials,
  fetchCoordNonSecureAncillaryMaterials,
  setupNonSecureAncillaryMaterialsFormData,
  clearNonSecureAncillaryMaterialsFormData,
  addFetchAction,
  removeFetchAction,
}) => {
  const [testingMaterialsPanels, setTestingMaterialsPanels] = useState([])

  useEffect(() => {
    addFetchAction({
      name: 'fetchCoordNonSecureAncillaryMaterials',
      action: (orgId, educationPeriodCd) =>
        fetchCoordNonSecureAncillaryMaterials(orgId, educationPeriodCd),
    })
    return () => removeFetchAction('fetchCoordNonSecureAncillaryMaterials')
  }, [])

  useEffect(() => {
    if (fetched && Object.keys(allTestingMaterials)?.length > 0) {
      const panels = []
      PANEL_ORDER.forEach(({ testAdmin, displayName }) => {
        if (allTestingMaterials[testAdmin] && Object.keys(allTestingMaterials[testAdmin]).length) {
          panels.push({
            title: `${displayName} Testing Materials`,
            PanelBody: () => <NonSecureMaterialsTestWindowPanel testWindow={testAdmin} />,
            panelId: `${testAdmin.replace(/\s/, '').toLowerCase()}TestingMaterials`,
          })
        }
      })
      setTestingMaterialsPanels(panels)
      const availableTestingWindowMaterials = PANEL_ORDER.reduce(
        (acc, { testAdmin }) => Object.assign(acc, allTestingMaterials[testAdmin]),
        {}
      )
      setupNonSecureAncillaryMaterialsFormData(availableTestingWindowMaterials)
    }
    return () => clearNonSecureAncillaryMaterialsFormData()
  }, [fetched, allTestingMaterials])

  if (error) return <Error title="Error Retrieving Data" message={error} />

  if (fetching) return <Loader />

  return (
    <>
      {testingMaterialsPanels.length > 0 && (
        <form name={OTHER_MATERIALS_FORM_NAME} onSubmit={e => e.preventDefault()}>
          <Accordions id="testingMaterials" panels={testingMaterialsPanels} />
        </form>
      )}
    </>
  )
}

export default connect(mapStateToProps, {
  fetchCoordNonSecureAncillaryMaterials,
  setupNonSecureAncillaryMaterialsFormData,
  clearNonSecureAncillaryMaterialsFormData,
  addFetchAction,
  removeFetchAction,
})(NonSecureMaterialsOrderForm)
